export const banksConfig = [
  { bank: "Axis Bank Ltd.", ifsc: "UTIB", img: "bi_axisbank" },
  { bank: "Bandhan Bank Ltd.", ifsc: "BDBL", img: "bi_bandhanbank" },
  { bank: "CSB Bank Limited", ifsc: "CSBK", img: "bi_csb" },
  { bank: "City Union Bank Ltd.", ifsc: "CIUB", img: "bi_cityunionbank" },
  { bank: "DCB Bank Ltd.", ifsc: "DCBL", img: "bi_dcbbank" },
  { bank: "Dhanlaxmi Bank Ltd.", ifsc: "DLXB", img: "bi_dhanbank" },
  { bank: "Federal Bank Ltd.", ifsc: "FDRL", img: "bi_federalbank" },
  { bank: "HDFC Bank Ltd", ifsc: "HDFC", img: "bi_hdfcbank" },
  { bank: "ICICI Bank Ltd.", ifsc: "ICIC", img: "bi_icicibank" },
  { bank: "IndusInd Bank Ltd", ifsc: "INDB", img: "bi_indusind" },
  { bank: "IDFC FIRST Bank Limited", ifsc: "IDFB", img: "bi_idfcbank" },
  { bank: "Jammu & Kashmir Bank Ltd.", ifsc: "JAKA", img: "bi_jkbank" },
  { bank: "Karnataka Bank Ltd.", ifsc: "KARB", img: "bi_karnatakabank" },
  { bank: "Karur Vysya Bank Ltd.", ifsc: "KVBL", img: "bi_kvb" },
  { bank: "Kotak Mahindra Bank Ltd", ifsc: "KKBK", img: "bi_kotak" },
  { bank: "Nainital Bank Ltd.", ifsc: "NTBL", img: "bi_nainitalbank" },
  { bank: "RBL Bank Ltd.", ifsc: "RATN", img: "bi_rblbank" },
  {
    bank: "South Indian Bank Ltd.",
    ifsc: "SIBL",
    img: "bi_southindianbank",
  },
  { bank: "Tamilnad Mercantile Bank Ltd.", ifsc: "TMBL", img: "bi_tmb" },
  { bank: "YES Bank Ltd.", ifsc: "YESB", img: "bi_yesbank" },
  { bank: "IDBI Bank Limited", ifsc: "IBKL", img: "bi_idbi" },
  {
    bank: "Coastal Local Area Bank Ltd",
    ifsc: "COAS",
    img: "bi_coastalareabank",
  },
  {
    bank: "Krishna Bhima Samruddhi LAB Ltd",
    ifsc: "KBSX",
    img: "bi_kbsbankindia",
  },
  { bank: "Au Small Finance Bank Ltd.", ifsc: "AUBL", img: "bi_aubank" },
  {
    bank: "Capital Small Finance Bank Ltd.",
    ifsc: "CLBL",
    img: "bi_capitalbank",
  },
  {
    bank: "Fincare Small Finance Bank Ltd.",
    ifsc: "FSFB",
    img: "bi_fincarebank",
  },
  {
    bank: "Equitas Small Finance Bank Ltd",
    ifsc: "ESFB",
    img: "bi_equitasbank",
  },
  {
    bank: "ESAF Small Finance Bank Ltd.",
    ifsc: "ESMF",
    img: "bi_esafbank",
  },
  {
    bank: "Suryoday Small Finance Bank Ltd.",
    ifsc: "SURY",
    img: "bi_suryodaybank",
  },
  {
    bank: "Ujjivan Small Finance Bank Ltd.",
    ifsc: "UJVN",
    img: "bi_ujjivansfb",
  },
  {
    bank: "Utkarsh Small Finance Bank Ltd.",
    ifsc: "UTKS",
    img: "bi_utkarsh",
  },
  {
    bank: "North East Small Finance Bank Ltd",
    ifsc: "NESF",
    img: "bi_nesfb",
  },
  {
    bank: "Jana Small Finance Bank Ltd.",
    ifsc: "JSFB",
    img: "bi_janabank",
  },
  {
    bank: "Shivalik Small Finance Bank Ltd",
    ifsc: "SMCB",
    img: "bi_shivalikbank",
  },
  {
    bank: "Unity Small Finance Bank Ltd",
    ifsc: "UNBA",
    img: "bi_theunitybank",
  },
  { bank: "Airtel Payments Bank Ltd", ifsc: "AIRP", img: "bi_airtel" },
  {
    bank: "India Post Payments Bank Ltd",
    ifsc: "IPOS",
    img: "bi_ippbonline",
  },
  { bank: "FINO Payments Bank Ltd", ifsc: "FINO", img: "bi_finobank" },
  { bank: "Paytm Payments Bank Ltd", ifsc: "PYTM", img: "bi_paytmbank" },
  {
    bank: "Jio Payments Bank Ltd",
    ifsc: "JIOP",
    img: "bi_jiopaymentsbank",
  },
  {
    bank: "NSDL Payments Bank Limited",
    ifsc: "NSPB",
    img: "bi_nsdlbank",
  },
  { bank: "Bank of Baroda", ifsc: "BARB", img: "bi_bankofbaroda" },
  { bank: "Bank of India", ifsc: "BKID", img: "bi_bankofindia" },
  {
    bank: "Bank of Maharashtra",
    ifsc: "MAHB",
    img: "bi_bankofmaharashtra",
  },
  { bank: "Canara Bank", ifsc: "CNRB", img: "bi_canarabank" },
  {
    bank: "Central Bank of India",
    ifsc: "CBIN",
    img: "bi_centralbankofindia",
  },
  { bank: "Indian Bank", ifsc: "IDIB", img: "bi_indianbank" },
  { bank: "Indian Overseas Bank", ifsc: "IOBA", img: "bi_iob" },
  {
    bank: "Punjab & Sind Bank",
    ifsc: "PSIB",
    img: "bi_punjabandsindbank",
  },
  { bank: "Punjab National Bank", ifsc: "PUNB", img: "bi_pnbindia" },
  { bank: "State Bank of India", ifsc: "SBIN", img: "bi_sbi" },
  { bank: "UCO Bank", ifsc: "UCBA", img: "bi_ucobank" },
  {
    bank: "Union Bank of India",
    ifsc: "UBIN",
    img: "bi_unionbankonline",
  },
  {
    bank: "National Bank for Agriculture and Rural Development",
    ifsc: "NBRD",
    img: "bi_nabard",
  },
  {
    bank: "Export-Import Bank of India",
    ifsc: "EIBI",
    img: "bi_eximbankindia",
  },
  { bank: "National Housing Bank", ifsc: "HDFC", img: "bi_nabard" },
  {
    bank: "Small Industries Development Bank of India",
    ifsc: "SIDB",
    img: "bi_sidbi",
  },
  { bank: "Assam Gramin Vikash Bank", ifsc: "AGVX", img: "bi_agvbank" },
  {
    bank: "Andhra Pradesh Grameena Vikas Bank",
    ifsc: "APGV",
    img: "bi_apgvbank",
  },
  { bank: "Andhra Pragathi Grameena Bank", ifsc: "APGB", img: "bi_apgb" },
  {
    bank: "Arunachal Pradesh Rural Bank",
    ifsc: "APRX",
    img: "bi_apruralbank",
  },
  { bank: "Aryavart Bank", ifsc: "ARYX", img: "bi_aryavart-rrb" },
  { bank: "Bangiya Gramin Vikash Bank", ifsc: "BGVX", img: "bi_bgvb" },
  { bank: "Baroda Gujarat Gramin Bank", ifsc: "BGGX", img: "bi_bggb" },
  {
    bank: "Baroda Rajasthan Kshetriya Gramin Bank",
    ifsc: "BRGX",
    img: "bi_brkgb",
  },
  { bank: "Baroda UP Bank", ifsc: "BUGX", img: "bi_barodaupbank" },
  { bank: "Chaitanya Godavari GB", ifsc: "CGGX", img: "bi_cggb" },
  {
    bank: "Chhattisgarh Rajya Gramin Bank",
    ifsc: "CRGB",
    img: "bi_cgbank",
  },
  { bank: "Dakshin Bihar Gramin Bank", ifsc: "MBGX", img: "bi_dbgb" },
  { bank: "Ellaquai Dehati Bank", ifsc: "EDBX", img: "bi_edb" },
  { bank: "Himachal Pradesh Gramin Bank", ifsc: "HMBX", img: "bi_hpgb" },
  { bank: "J&K Grameen Bank", ifsc: "XJKG", img: "bi_jkgb" },
  { bank: "Jharkhand Rajya Gramin Bank", ifsc: "VGBX", img: "bi_jrgb" },
  {
    bank: "Karnataka Gramin Bank",
    ifsc: "PKGB",
    img: "bi_karnatakagraminbank",
  },
  {
    bank: "Karnataka Vikas Gramin Bank",
    ifsc: "KVGB",
    img: "bi_kvgbank",
  },
  { bank: "Kerala Gramin Bank", ifsc: "KLGB", img: "bi_keralagbank" },
  { bank: "Madhya Pradesh Gramin Bank", ifsc: "CMPX", img: "bi_mpgb" },
  { bank: "Madhyanchal Gramin Bank", ifsc: "MADX", img: "bi_mgbank" },
  { bank: "Maharashtra Gramin Bank", ifsc: "MAHG", img: "bi_mahagramin" },
  {
    bank: "Manipur Rural Bank",
    ifsc: "MRBX",
    img: "bi_manipurruralbank",
  },
  {
    bank: "Meghalaya Rural Bank",
    ifsc: "MERX",
    img: "bi_meghalayaruralbank",
  },
  {
    bank: "Mizoram Rural Bank",
    ifsc: "MZRX",
    img: "bi_mizoramruralbank",
  },
  {
    bank: "Nagaland Rural Bank",
    ifsc: "NAGX",
    img: "bi_nagalandruralbank",
  },
  { bank: "Odisha Gramya Bank", ifsc: "ODGB", img: "bi_odishabank" },
  { bank: "Paschim Banga Gramin Bank", ifsc: "PASX", img: "bi_pbgbank" },
  {
    bank: "Prathama U.P. Gramin Bank",
    ifsc: "SUBX",
    img: "bi_prathamaupbank",
  },
  {
    bank: "Puduvai Bharathiar Grama Bank",
    ifsc: "PBGX",
    img: "bi_puduvaibharathiargramabank",
  },
  { bank: "Punjab Gramin Bank", ifsc: "PUGX", img: "bi_pgb" },
  {
    bank: "Rajasthan Marudhara Gramin Bank",
    ifsc: "RMGB",
    img: "bi_rmgb",
  },
  {
    bank: "Saptagiri Grameena Bank",
    ifsc: "SPBX",
    img: "bi_saptagirigrameenabank",
  },
  { bank: "Sarva Haryana Gramin Bank", ifsc: "HGBX", img: "bi_shgb" },
  { bank: "Saurashtra Gramin Bank", ifsc: "SGBA", img: "bi_sgbrrb" },
  {
    bank: "Tamil Nadu Grama Bank",
    ifsc: "IDIB",
    img: "bi_tamilnadugramabank",
  },
  { bank: "Telangana Grameena Bank", ifsc: "DGBX", img: "bi_tgbhyd" },
  {
    bank: "Tripura Gramin Bank",
    ifsc: "TGBX",
    img: "bi_tripuragraminbank",
  },
  { bank: "Uttar Bihar Gramin Bank", ifsc: "UBGX", img: "bi_ubgb" },
  {
    bank: "Utkal Grameen Bank",
    ifsc: "UGBX",
    img: "bi_utkalgrameenbank",
  },
  {
    bank: "Uttarbanga Kshetriya Gramin Bank",
    ifsc: "UKGX",
    img: "bi_ubkgb",
  },
  { bank: "Vidharbha Konkan Gramin Bank", ifsc: "BKID", img: "bi_vkgb" },
  {
    bank: "Uttarakhand Gramin Bank",
    ifsc: "UTGX",
    img: "bi_uttarakhandgraminbank",
  },
  { bank: "AB Bank Ltd.", ifsc: "ABBL", img: "bi_abbl" },
  {
    bank: "American Express Banking Corporation",
    ifsc: "XXXX",
    img: "bi_americanexpress",
  },
  {
    bank: "Australia and New Zealand Banking Group Ltd.",
    ifsc: "ANZB",
    img: "bi_anz",
  },
  { bank: "Barclays Bank Plc.", ifsc: "BARC", img: "bi_barclays" },
  { bank: "Bank of America", ifsc: "BOFA", img: "bi_bofa-india" },
  {
    bank: "Bank of Bahrain & Kuwait B.S.C.",
    ifsc: "BBKM",
    img: "bi_bbkindia",
  },
  { bank: "Bank of Ceylon", ifsc: "BCEY", img: "bi_bankofceylon" },
  { bank: "Bank of China", ifsc: "BCHN", img: "bi_bankofchina" },
  { bank: "Bank of Nova Scotia", ifsc: "NOSC", img: "bi_scotiabank" },
  { bank: "BNP Paribas", ifsc: "BNPA", img: "bi_bnpparibas" },
  { bank: "Citibank N.A.", ifsc: "CITI", img: "bi_citibank" },
  { bank: "Cooperatieve Rabobank", ifsc: "RABO", img: "bi_rabobank" },
  {
    bank: "Credit Agricole Corporate & Investment Bank",
    ifsc: "CRLY",
    img: "bi_ca-cib",
  },
  { bank: "Credit Suisse AG", ifsc: "CRES", img: "bi_credit-suisse" },
  {
    bank: "CTBC Bank Co., Ltd.",
    ifsc: "CTCB",
    img: "bi_chinatrustindia",
  },
  { bank: "DBS Bank India Limited", ifsc: "DBSS", img: "bi_dbs" },
  { bank: "Deutsche Bank A.G.", ifsc: "DEUT", img: "bi_deutschebank" },
  { bank: "Doha Bank Q.P.S.C", ifsc: "DOHB", img: "bi_dohabank" },
  { bank: "Emirates NBD Bank PJSC", ifsc: "EBIL", img: "bi_emiratesnbd" },
  { bank: "First Abu Dhabi Bank PJSC", ifsc: "NBAD", img: "bi_bankfab" },
  { bank: "FirstRand Bank Limited", ifsc: "FIRN", img: "bi_firstrand" },
  {
    bank: "Hong Kong and Shanghai Banking Corporation Limited",
    ifsc: "HSBC",
    img: "bi_hsbc",
  },
  {
    bank: "Industrial & Commercial Bank of China Ltd.",
    ifsc: "ICBK",
    img: "bi_icbcindia",
  },
  { bank: "Industrial Bank of Korea", ifsc: "IBKO", img: "bi_globalibk" },
  {
    bank: "J.P. Morgan Chase Bank N.A.",
    ifsc: "CHAS",
    img: "bi_jpmorgan",
  },
  { bank: "JSC VTB Bank", ifsc: "IBKL", img: "bi_vtbindia" },
  { bank: "KEB Hana Bank", ifsc: "KOEX", img: "bi_1qbank" },
  { bank: "Kookmin Bank", ifsc: "KBKB", img: "bi_kbfg" },
  {
    bank: "Krung Thai Bank Public Co. Ltd.",
    ifsc: "KRTH",
    img: "bi_krungthai",
  },
  { bank: "Mashreq bank PSC", ifsc: "MSHQ", img: "bi_mashreqbank" },
  { bank: "Mizuho Bank Ltd.", ifsc: "MHCB", img: "bi_mizuhobank" },
  { bank: "MUFG Bank, Ltd.", ifsc: "BOTM", img: "bi_mufg" },
  { bank: "NatWest Markets Plc", ifsc: "ABNA", img: "bi_natwestmarkets" },
  {
    bank: "PT Bank Maybank Indonesia TBK",
    ifsc: "IBBK",
    img: "bi_maybank",
  },
  { bank: "Qatar National Bank (Q.P.S.C.)", ifsc: "QNBA", img: "bi_qnb" },
  { bank: "Sberbank", ifsc: "SABR", img: "bi_sberbank" },
  { bank: "SBM Bank (India) Limited", ifsc: "STCB", img: "bi_sbmbank" },
  { bank: "Shinhan Bank", ifsc: "SHBK", img: "bi_shinhanglobal" },
  {
    bank: "Societe Generale India",
    ifsc: "SOGE",
    img: "bi_societegenerale",
  },
  { bank: "Sonali Bank Ltd.", ifsc: "SBLD", img: "bi_sonalibank" },
  { bank: "Standard Chartered Bank", ifsc: "SCBL", img: "bi_sc" },
  {
    bank: "Sumitomo Mitsui Banking Corporation",
    ifsc: "SMBC",
    img: "bi_smbc",
  },
  {
    bank: "United Overseas Bank Limited",
    ifsc: "UOVB",
    img: "bi_uobgroup",
  },
  { bank: "Woori Bank", ifsc: "HVBK", img: "bi_wooribank" },
];

export const getBankLogo = (ifsc, name) => {
  const trimmedIFSC = ifsc?.trim()?.substring(0, 4)?.toUpperCase()
  const trimmedName = name?.toLowerCase()
  
  const ifscIdx = banksConfig.findIndex(
    (element) =>
      element.ifsc.toUpperCase() === trimmedIFSC
  );

  if (ifscIdx !== -1) {
    return `/dashboard/bank-logo/${banksConfig[ifscIdx].img}.png`;
  }

  const nameIdx = banksConfig.findIndex(
    (element) => element.bank.toLowerCase() === trimmedName
  );

  if (nameIdx !== -1) {
    return `/dashboard/bank-logo/${nameIdx[ifscIdx].img}.png`;
  } else {
    return `/dashboard/bank-logo/default.svg`;
  }
};
